<script setup lang="ts">
import { DropdownMenuContent, DropdownMenuPortal, DropdownMenuRoot, DropdownMenuTrigger } from 'reka-ui'

/** A compact popover menu: closes on outside click, Escape and selection, and returns focus to its trigger. */
withDefaults(defineProps<{ side?: 'top' | 'bottom' | 'right'; align?: 'start' | 'end' }>(), {
  side: 'top',
  align: 'start',
})
</script>

<template>
  <DropdownMenuRoot>
    <DropdownMenuTrigger as-child><slot name="trigger" /></DropdownMenuTrigger>
    <DropdownMenuPortal>
      <DropdownMenuContent
        :side="side"
        :align="align"
        :side-offset="8"
        class="z-50 flex w-72 max-w-[calc(100vw-1rem)] flex-col gap-[var(--space-hair)] rounded-[var(--radius-overlay)] border border-[color:var(--color-border)] bg-[color:var(--color-surface)] p-[var(--space-tight)] shadow-[var(--shadow-overlay)]"
      >
        <slot />
      </DropdownMenuContent>
    </DropdownMenuPortal>
  </DropdownMenuRoot>
</template>
